module.exports = __webpack_public_path__ + "assets/img/educator_register_without_roy.e1e1942c.png";